import { useEffect, useMemo } from "react";
import {
  Typography,
  DeleteButton,
  useDataGrid,
  DataGrid,
  List,
  itIT,
} from "@pankod/refine-mui";
import { Stack } from "@pankod/refine-mui";
import { Link } from "@pankod/refine-react-router-v6";

import { useGetIdentity } from "@pankod/refine-core";

function BuyerList() {
  const { data: user } = useGetIdentity();

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID" },
      {
        field: "company",
        headerName: "Nome Azienda",
        flex: 1,
        minWidth: 300,
      },
      {
        field: "municipality",
        headerName: "Comune di appartenenza",
        flex: 1,
        minWidth: 100,
        maxWidth: 300,
        renderCell: function render(p) {
          return <span>{p.row.municipality.name}</span>;
        },
      },
      {
        field: "email",
        headerName: "Email",
        flex: 1,
        minWidth: 300,
      },
      {
        field: "user_category",
        headerName: "Categoria",
        flex: 1,
        minWidth: 100,
        maxWidth: 300,
        renderCell: function render(p) {
          return <span>{p.row.user_category.name}</span>;
        },
      },
      {
        field: "status",
        headerName: "status",
        flex: 1,
        minWidth: 100,
        maxWidth: 300,
        renderCell: function render(p) {
          return (
            <span>
              {p.row.status === "submitted"
                ? "Da approvare"
                : p.row.status === "accepted"
                ? "Approvato"
                : "Non approvato"}
            </span>
          );
        },
      },
      {
        headerName: "Actions",
        field: "actions",
        minWidth: 50,
        renderCell: function render(p) {
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <Link to={`/acquirenti/${p.row.id}`}>VEDI</Link>
              {user?.role == "authenticated" && (
                <DeleteButton
                  hideText
                  resourceNameOrRouteName="registration-requests"
                  recordItemId={p.row.id}
                />
              )}
            </Stack>
          );
        },
      },
    ],
    []
  );

  const { dataGridProps, setFilters } = useDataGrid({
    resource: "registration-requests",
    metaData: {
      populate: { municipality: { fields: ["name"] }, user_category: true },
    },
  });

  useEffect(() => {
    setFilters([
      {
        field: "is_seller",
        value: false,
        operator: "eq",
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <List
      resource="registration-requests"
      createButtonProps={{ size: "small" }}
      canCreate={false}
      headerProps={{
        title: <Typography variant="h5">ELENCO ACQUIRENTI</Typography>,
      }}
    >
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      />
    </List>
  );
}

export default BuyerList;
